// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/data/jenkins/workspace/exam-platform-front@2/src/models/enum';

export const models = {
model_1: { namespace: 'enum', model: model_1 },
} as const
